module.exports = __webpack_public_path__ + "static/media/img4.29a0a093.jpeg";